export default {
    materialCostUsdPerSqftBasic: 2.40,
    materialCostUsdPerSqftGood: 2.55,
    materialCostUsdPerSqftPremium: 2.70,
    roofComplexityMultiplierSimple: 0,
    roofComplexityMultiplierMoreComplex: 0.1,
    roofComplexityMultiplierVeryComplex: 0.25,
    layerComplexityMultiplier: 0.15,
    laborCostUsdPerSqftSubContracted: 1.75,
    laborCostUsdPerSqftFactoryCertified: 2.25,
    wasteRemovalMaxSqftPerDumpster: 2500,
    wasteRemovalCostUsdPerDumpster: 700,
    wasteRemovalCostUsdAdditionalWastePerSqft: 0.22,
    lowerRangePercent: 8,
    upperRangePercent: 8,
}
